
export enum Checks {
  Zdfy = 1, //自动发药
  Psgl = 2,//皮试管理
  Gbxgjg = 3, //关闭修改价格
  Gbkdysstx = 4,//关闭开单医生提醒
  Zdrjsj = 5, //指定日结时间
  Jzrqsd = 6, //结转日期设定
  Mrzffs = 7, //默认支付方式
  Zjjs = 8, //诊间结算
  Lkcky = 9, //零库存开药
  LKSC = 10, //商城
  ZNFZ = 11, //辅助诊断
  LJWPSSF = 14, //拦截未皮试的收费
  ZCYNDJTED = 20, //中草药年度帖均额度
  YBJJNDZFXE = 21, //医保基金年度支付限额
  YBLZYLFNDZFXE = 22, //医保列支医疗费年度支付限额
  RCRTB = 23, //人次人头比
  CJNDFYXE = 24, //次均年度费用限额
  RJNDFYXE = 25, //人均年度费用限额
  SJHM = 26, //手机号码
  TSPL = 27, // 推送频率
  CFJDYCFJE = 28, // 处方笺是否打印处方金额
  CFJDYCJHPCH = 33, //处方笺打印厂家与批次号
  CFJDYBZ = 35, //处方笺打印备注
  FYFS = 17, //发药方式
  ISEDIT = 18, //是否允许修改病历
  JEML = 31, //金额抹零
  HZFZBJ = 34, //患者复诊标记
  CFJDYBLH = 32, //处方笺是否打印病历号条码
  ZDJSTS = 36, //自动计算天数(保存前)
  CFJDYZS = 37, //处方笺打印主诉
  CFJDYZZL = 39, //处方笺打诊疗
  CFJDYZCL = 40, //处方笺打材料
  CFJDYZZC = 41, //收据展示折扣
  CFJDYDAYS = 53, //打印天数
  FPXZ = 42, //模板
  LSDJ = 43, //零售单号
  SCCS = 44, //生产厂商
  PCHYXQ = 45, //批次号/有效期
  DJDW = 46,//单价/单位
  FZLWTGBTH = 47, //售出药品非质量问题概不退换
  JGLXDH = 48, //机构联系电话
  JYYSKQ = 49, //每次医保结算时校验医生考勤
  OVERLIMITSIGN = 50, //超出医保支付价时，需要患者签字确认
  PRINTCABINENO = 52, //打印柜号
  AUTODAILY = 54, //自动日结
  ZDJSTSBCH = 55, //自动计算天数(保存后)
  KFZDSCFY = 56, //开方自动生成费用
  ZYKFWSTX = 57,
  AdvancedMedical = 51,//高级病历 新医美
  AI = 101,//AI服务
  YBTJ = 102,//医保帖均
  CFYDJ = 104, //处方药登记
  TREATMENT_ATTACH = 105, //临时病历附加信息开关
  REMINDERALARM_WHENPAY = 106, //是否需要将处方提示信息推送到收费页面
  ZSMSC = 107, //购入入库追溯码上传
  ZDJSSJ = 108, //自动计算售价
  SJTB = 109,//购入入库数据同步
  DZHZDHT = 110, //入库单价回填
  YPSSFS = 111, //药品搜索方式
  INSURANCE310LIMIT = 112,//职工医保月均限额
  INSURANCE390LIMIT = 113, //城乡医保月均限额
  XYKCXX = 114, // 西药库存下限
  ZYKCXX = 115, // 中药库存下限
  CLKCXX = 116, // 材料库存下限
  QXKCXX = 117, // 器械库存下限
  ZCYKCXX = 118, // 中成药库存下限
  QTKCXX = 119, // 其他库存下限
  MEZDQDSL = 120, // 默认自动清斗数量
  KFZDHTBZZCF = 121, // 开方自动回填备注至处方 //开方时备注回填
  YJFYHZDDY = 122, // 一键发药后自动打印
  ZDPDZQ = 123, //自动盘点周期
  ZDPDKF = 124, // 一键发药后自动打印
  RKDJHT = 125, // 入库单价回填
  LSDJHT = 126, // 零售单价回填
  XLKCXX = 127 ,//细料库存下限
  FLKCXX = 128, //辅料库存下限
  ZYFCOPY = 129, //中药方复制设置
  ZSMTXFS = 130, //追溯码提醒方式
  ZYFMRDJ = 131, //中药方默认打开代煎
  KFGLTX = 134, //开方超量提醒
  VOICEAI = 135, //语音AI病例
  AITCMSUGGESS = 136, //中医AI推荐处方
  WXRT = 137, //年度人头基金数 无效人头开关
  FZCFJG = 138, //复制处方价格
  FZCTJG = 139, //添加套餐价格
  KZXSJ = 2001,//护士站设置可执行时机（1.诊断完毕时和结算时候创建执行单，2.结算时创建执行单，3.不使用）
  WXRTZGYL = 140, //年度人头基金数 无效人头开关-职工医疗保险
  WXRTJMYL = 141, //年度人头基金数 无效人头开关-居民医疗保险
  MLKG = 142, // 目录库规格展示方式
  YBSQZDTX = 143,//医保事前自动提醒
  DZBLCTSD = 144,//电子病历词条锁定
  CSCFJXSZ = 145,//初始处方剂型设置
  CSCFJXSZNR = 146,//初始处方剂型设置内容
  ZYBLXYZDXY = 147,//中医病历西医诊断校验
  CFYPZLXZ = 148,//处方药品种类限制
  SZYLJS = 149,//输注用量计算
  WHYLJS = 150,//雾化用量计算
  FJSCDXZ = 151,////单个附件上传大小限制
  KCBZS = 152, //库存不足时
  SPJJ = 153, //药店开单商品进价
  PLUG_REMINDER = 160, //是否开启内部预警提醒插件
  ZYCCJJ25ZZF = 154, //中药超进价25%转资费
  SFXMJEJSFS = 155, //收费金额计算方式
  GHFJSFS = 156, //挂号费计算方式
  ZFJEJSFS = 157, //自费金额计算方式
 }

export const CheckOptions = [
  Checks.Zdfy,
  Checks.Psgl,
  Checks.Gbxgjg,
  Checks.Gbkdysstx,
  Checks.Zdrjsj,
  Checks.Jzrqsd,
  Checks.Mrzffs,
  Checks.ZNFZ,
]

export const CheckNames = [
  '自动发药',
  '皮试管理',
  '关闭修改价格(医生)',
  '关闭开单医生提醒',
  '指定日结时间',
  '结转日期设定',
  '默认支付方式',
  '零库存开药',
  '库存不足时',
]

export function getCheckName(check: Checks): string {
  if (check < 0 || check >= CheckNames.length) {
    return ''
  }
  return CheckNames[check]
}

export interface Settinglable {
  id?: string
  type?: string
  value?: string
  tenentId?: string
}

export class Settings {
  static Registration = class {
    static readonly SkipPrinting = 'settings.registration.printing.skip'
  }

  static AI = class {
    //是否开通AI功能
    static readonly MAIN_SWITCH = 'settings.ai.main_switch'
    //是否开通语音AI功能
    static readonly VOICE_AI_SWITCH = 'settings.voice.ai.main_switch'
    //是否开通中医推荐处方
    static readonly AI_TCM_SUGGESS = 'settings.tcm.recipeSuggesstion'

  }
  static Treatment = class {
    // 接诊医生提醒
    static readonly DoNotWarnDoctorMismatch =
      'settings.treatment.do-not-warn-doctor-mismatch'
    // 诊间结算
    static readonly Settlement = 'settings.treatment.settlement'
    // 医美高级病历
    static readonly highTreatmentTemplate = 'settings.treatment.highTreatmentTemplate'
    // 护士工作站执行方式
    static readonly  nurseStationWay = 'settings.treatment.nurseStationWay'
    // 是否开启监管提醒插件
    static readonly  plugReminder = 'settings.treatment.plugReminder'
  }

  static Recipe = class {
    static readonly UseSpecifiedBatch = 'settings.recipe.use-specified-batch'
    static readonly IgnoreStorage = 'settings.recipe.ignore-storage'
    static readonly TcmUseSpecifiedBatch =
      'settings.recipe.tcm-use-specified-batch'
    static readonly TcmIgnoreStorage = 'settings.recipe.tcm-ignore-storage'
    static readonly ChangePrice = 'settings.recipe.change-price'
    static readonly AutoChangePrice = 'settings.recipe.auto-change-price'
    static readonly ReminderAlarmWhenPay = 'settings.recipe.reminder-when-pay'

    static readonly AutoChangePriceAfter = 'settings.recipe.auto-change-price-after'
  }

  static Payment = class {
    static readonly DefautMethod = 'settings.payment.default-method'
  }

  static Printing = class {
    static readonly Preview = 'settings.printing.preview'

    static readonly HasTreatmentTemplate =
      'settings.printing.has-treatment-template'
  }
}

export interface MedicelListValue {
  cityHospitalNb: string
  countryHospitalNb: string
  endTime: string
  id: number
  insuranceCode: string
  insuranceName: string
  isFaceCall: number
  linkPort: string
  recordType: number
  startTime: string
  sysStatus: number
  tenantId: number
  tenantStatus: number
  ybIp: string
  ybMac: string
  yidiHospitalNb: string
}

export interface insuranceCodeValue {
  createTime: string
  insuranceCode: string
  insuranceName: string
  isFaceCall: number
  linkPort: string
  recordType: number
  status: number
  updateTime: string
}

export enum AccountType {
  ALL = '2',
  YAC = '0',
  NAC = '1',
}

export const AccountTypes = [AccountType.ALL, AccountType.YAC, AccountType.NAC]

export const getAccountTypeName = (accountType: AccountType) => {
  switch (accountType) {
    case AccountType.ALL:
      return '全部'
    case AccountType.YAC:
      return '对账一致'
    case AccountType.NAC:
      return '对账不一致'
  }
}
